var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mt-5" }, [
      _c(
        "form",
        {
          staticClass: "col-12 col-sm-8 col-lg-6 m-auto",
          attrs: { id: "signup_form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h1", [_vm._v(_vm._s(_vm._f("trans")("st_public.signup")))])
            ]),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("trans")("st_public.name")))
                ]),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.name,
                        expression: "name"
                      }
                    ],
                    class: {
                      "form-control": true,
                      "border-danger": _vm.errors.has("name")
                    },
                    attrs: { type: "text", name: "name" },
                    domProps: { value: _vm.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.name = $event.target.value
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("name"),
                        expression: "errors.has('name')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("name")))]
                )
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("trans")("st_public.email")))
                ]),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    class: {
                      "form-control": true,
                      "border-danger": _vm.errors.has("email")
                    },
                    attrs: { type: "text", name: "email" },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("email"),
                        expression: "errors.has('email')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("email")))]
                )
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("trans")("st_public.password")))
                ]),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    class: {
                      "form-control": true,
                      "border-danger": _vm.errors.has("password")
                    },
                    attrs: { type: "password", name: "password" },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("password"),
                        expression: "errors.has('password')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("password")))]
                )
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm._f("trans")("st_public.password_confirmation"))
                  )
                ]),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password_confirmation,
                        expression: "password_confirmation"
                      }
                    ],
                    class: {
                      "form-control": true,
                      "border-danger": _vm.errors.has("password_confirmation")
                    },
                    attrs: { type: "password", name: "password_confirmation" },
                    domProps: { value: _vm.password_confirmation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password_confirmation = $event.target.value
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("password_confirmation"),
                        expression: "errors.has('password_confirmation')"
                      }
                    ],
                    staticClass: "invalid-feedback"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("password_confirmation")))]
                )
              ]),
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg mt-3",
                    attrs: { type: "submit" }
                  },
                  [
                    _c("span", { staticClass: "fa fa-save" }),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm._f("trans")("st_public.signup")) +
                        "\n                        "
                    )
                  ]
                ),
                _c(
                  "div",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { name: "lang-login", params: { lang: _vm.lang } }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")("st_public.already_have_account")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      )
    ]),
    _vm.loading ? _c("div", { staticClass: "loading-page" }) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c42e7ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c42e7ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/old-signup-2018-03-03.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7c42e7ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/old-signup-2018-03-03.vue
// module chunks = 36